import classNames from "classnames";
import { useRef } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { SidebarInset, SidebarProvider, useSidebar } from "../ui/sidebar";
import "./style.scss";

function AdminContent({ siderOpen }) {
	const mainContentRef = useRef(null);
	const { toggleSidebar, open, openMobile, isMobile } = useSidebar();

	return (
		<>
			<Sidebar />

			<SidebarInset
				ref={mainContentRef}
				className={classNames("main-content", "tw-min-h-0 tw-overflow-hidden", siderOpen && "sider-open")}
			>
				<Navbar
					toggleSidenav={toggleSidebar}
					sidenavOpen={isMobile ? openMobile : open}
				/>

				<div className="content">
					<Outlet />
				</div>
			</SidebarInset>
		</>
	);
}

function Admin({ siderOpen = false }) {
	return (
		<SidebarProvider className="tw-h-svh tw-overflow-hidden">
			<AdminContent siderOpen={siderOpen} />
		</SidebarProvider>
	);
}

export default Admin;
